export enum ButtonSize {
	FULL_WIDTH,
	LG,
	MD,
	SM,
	XS,
}
